import { Component, OnInit, Injector, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { FileUploadComponent } from 'src/app/out-of-application/file-upload/file-upload.component'
import { MailTemplateComponent } from 'src/app/out-of-application/mail-template/mail-template.component';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/Common/data.service';
import saveAs from 'file-saver';
@Component({
    selector: 'app-service-request',
    templateUrl: './service-request.component.html',
    styleUrls: ['./service-request.component.scss']
})
export class ServiceRequestComponent implements OnInit {
    ServiceRequestForm: UntypedFormGroup;
    ServiceRequestLogDetail: UntypedFormGroup;
    MailTEmplateDialogRef: MatDialogRef<MailTemplateComponent>;
    requesterList: any[] = []; //for angular upgrade
    locationList: any;
    categoryList: any;
    subcategoryList: any;
    statusList: any;
    priorityList: any;
    itemList: any;
    filterList: any;
    IsVisisble: false;
    detailedPath: any;
    ServiceRequestLogDetailList: any;
    assingmentGroupList: any;
    assignedToList: any;
    ID: string
    IsTypeWiseVisibility: boolean;
    IsButtonHide = true;
    isOk = false;

    constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
        private _activeRoute: ActivatedRoute, public _commonService: CommonService,
        injector: Injector, private _dialog: MatDialog, public _dataService: DataService,
        private status: HTTPStatus, private _serviceRequestService: ServiceRequestService,
        private cdr: ChangeDetectorRef
        // private spinnerService: Ng4LoadingSpinnerService
    ) {
    }

    ngOnInit() {
        /*****************************GetData By QueryString*************************/
        this.ID = this._activeRoute.snapshot.paramMap.get('ID');
        /**************************************End**********************************/
        this.ServiceRequestForm = this._fb.group({
            RequestEntityId: [''],
            RequisitionDate: [new Date()],
            RequestedforHead: ['', [Validators.required]],
            RequestedFor: [],
            RequestedForName: [],
            RequestedForGPN: [],
            RequestedForCUG: [''],
            ShortDescription: ['', [Validators.required]],
            LongDescription: [],// ['', [Validators.required]],
            RequesterName: [],
            RequesterHead: [],
            RequestedBy: [],
            RequestedByGPN: [],
            RequestedByCUG: [],
            CategoryId: ['', [Validators.required]],
            Category: [],
            SubCategoryId: ['', [Validators.required]],
            SubCategory: [],
            ItemId: ['', [Validators.required]],
            Item: [],
            ReqLocation: ['', [Validators.required]],
            Location: [],
            StatusID: ['', [Validators.required]],
            StatusName: [],
            PriorityID: [],
            Priority: [],
            IsRequestedFor: false,
            SRNumber: [],
            AssignmentGroupID: ['', [Validators.required]],
            AssignmentGroup: [],
            AdditionalComment: [],
            AssignedTo: [],
            AssignedToName: [],
            AssignedToEmail: [],
            AssignedEmp: [],
            ResolutionTime: [],


        });
        this.ServiceRequestLogDetail = this._fb.group({
            RequestEntityId: [],
            SRID: [],
            Type: [],
            LogText: [],
            MailTo: [],
            MailCC: [],
            MailBCC: [],
            CreatedBy: [],
            CreatedByName: [],
            CreatedOn: [],
            IPAddress: []

        })
        this.IsTypeWiseVisibility = false;
        this.BindCategoryList();
        this.BindLocationList();
        this.BindStatusList();
        this.BindPriorityList();
        this.GetServiceRequestDetailByID(this.ID);

    }
    BindCategoryList() {
        this._commonService.BindDropDown('category').subscribe(result => {
            this.categoryList = result;
            this.cdr.detectChanges();
        });
    }
    BindLocationList() {
        this._commonService.BindDropDown('location').subscribe(result => {
            this.locationList = result;
        });
    }
    BindStatusList() {
        this._commonService.BindDropDown('Status').subscribe(result => {
            this.statusList = result;
        });
    }
    BindPriorityList() {
        this._commonService.BindDropDown('priority').subscribe(result => {
            this.priorityList = result;
        });
    }

    GetSubCategoryName(event) {
        if (event.originalEvent !== undefined) {
            this.ServiceRequestForm.controls.Category.setValue(event.originalEvent.currentTarget.innerText);
        }
        this._commonService.BindDropDownWithParam('subcategory', event.value).subscribe(result => {
            this.subcategoryList = result;
        });
        this.ServiceRequestForm.controls.ItemId.setValue("");
        this.ServiceRequestForm.controls.AssignmentGroupID.setValue("");
        this.ServiceRequestForm.controls.AssignedTo.reset();
        this.ServiceRequestForm.controls.AssignedToName.reset();
        this.ServiceRequestForm.controls.AssignedToEmail.reset();
        this.itemList = [];
        this.assignedToList = [];
        this.assingmentGroupList = [];

    }
    BindItemName(event) {
        if (event.originalEvent !== undefined) {
            this.ServiceRequestForm.controls.SubCategory.setValue(event.originalEvent.currentTarget.innerText);
        }
        this._commonService.BindDropDownWithParam('item', event.value).subscribe(result => {
            this.itemList = result;
        });
        this.ServiceRequestForm.controls.AssignmentGroupID.setValue("");
        this.ServiceRequestForm.controls.AssignedTo.reset();
        this.ServiceRequestForm.controls.AssignedToName.reset();
        this.ServiceRequestForm.controls.AssignedToEmail.reset();
        this.assignedToList = [];
        this.assingmentGroupList = [];
    }

    BindAssigmentGroup(event, page) {
        if (event.originalEvent !== undefined) {
            this.ServiceRequestForm.controls.Item.setValue(event.originalEvent.currentTarget.innerText);
        }

        this._commonService.BindDropDownWithParam('assigmentgroup', event.value).subscribe(result => {
            this.assingmentGroupList = result;
        });
        if (page === 1) {
            this.ServiceRequestForm.controls.AssignedTo.reset();
            this.ServiceRequestForm.controls.AssignedToName.reset();
            this.ServiceRequestForm.controls.AssignedToEmail.reset();
            this.ServiceRequestForm.controls.AssignedEmp.reset();
            this.assignedToList = [];
        }
    }
    ChangeAssigmentGroup(event, page) {

        if (page === 1) {
            this.ServiceRequestForm.controls.AssignedTo.reset();
            this.ServiceRequestForm.controls.AssignedToName.reset();
            this.ServiceRequestForm.controls.AssignedToEmail.reset();
            this.ServiceRequestForm.controls.AssignedEmp.reset();
            this.assignedToList = [];
        }
    }
    GetServiceRequestDetailByID(ID: string) {

        this._serviceRequestService.GetServiceRequestDetailByID(ID).subscribe(data => {
            this.ServiceRequestForm.patchValue(data);
            this.assignedToList = {
                EmployeeGPN: data.AssignedTo, EmployeeName: data.AssignedToName, EmpEmail: data.AssignedToEmail
            };
            // for angular upgrade
            this.requesterList = new Array<any>({
                EmployeeGPN: data.RequestedForGPN,
                EmployeeName: data.RequestedFor,
            });

            this.ServiceRequestLogDetailList = data.srLogDetailList
            this.ServiceRequestForm.controls.AssignedEmp.setValue(this.assignedToList);
            this.ServiceRequestForm.controls.ReqLocation.setValue(String(data.ReqLocation));
            this.ServiceRequestForm.controls.CategoryId.setValue(String(data.CategoryId));
            this.GetSubCategoryName(this.ServiceRequestForm.controls.CategoryId);
            this.ServiceRequestForm.controls.SubCategoryId.setValue(String(data.SubCategoryId));
            this.BindItemName(this.ServiceRequestForm.controls.SubCategoryId);
            this.ServiceRequestForm.controls.ItemId.setValue(String(data.ItemId));
            this.BindAssigmentGroup(this.ServiceRequestForm.controls.ItemId, 0);
            this.ServiceRequestForm.controls.AssignmentGroupID.setValue(String(data.AssignmentGroupID));
            this.ServiceRequestForm.controls.AssignmentGroup.setValue(String(data.AssignmentGroup));
            this.ServiceRequestForm.controls.StatusID.setValue(String(data.StatusID));
            this.ServiceRequestForm.controls.PriorityID.setValue(String(data.PriorityID));
            this.ServiceRequestForm.controls.AssignedTo.setValue(String(data.AssignedTo));
            this.ServiceRequestForm.controls.AssignedToName.setValue(String(data.AssignedToName));
            this.ServiceRequestForm.controls.AssignedToEmail.setValue(String(data.AssignedToEmail));
            this.ServiceRequestForm.controls.ShortDescription.setValue(String(data.ShortDescription));
            this.ServiceRequestForm.controls.LongDescription.setValue(data.LongDescription);
            this.ServiceRequestForm.controls.SRNumber.setValue(data.SRNumber);
            this.ServiceRequestForm.controls.RequestedBy.setValue(data.RequestedBy)
            this.ServiceRequestForm.controls.RequestedByGPN.setValue(data.RequestedByGPN)
            this.ServiceRequestForm.controls.RequestedByCUG.setValue(data.RequestedByCUG)

            this.ServiceRequestForm.controls.RequestedforHead.setValue(this.requesterList[0].EmployeeName)
            this.ServiceRequestForm.controls.RequestedForGPN.setValue(data.RequestedForGPN)
            this.ServiceRequestForm.controls.RequestedForName.setValue(data.RequestedForName)
            this.ServiceRequestForm.controls.RequestedForCUG.setValue(data.RequestedForCUG)
            this.ServiceRequestForm.controls.IsRequestedFor.setValue(data.IsRequestedFor)
            this.ServiceRequestForm.controls.AdditionalComment.setValue(String(data.AdditionalComment));
            if (String(data.StatusID) == "4" || String(data.StatusID) == "5") {
                this.IsButtonHide = false;
                this.isOk = true;
            }
            this.cdr.detectChanges();
        }, (error) => {
            // this.status.setHttpStatus(false);

            this.error.handleError(error);
        }, () => {
            // this.spinnerService.hide();

            // this.status.setHttpStatus(false); 
        });
    }

    GetServiceRequestLogDetailByID(ID: string) {
        // this.spinnerService.show();
        //this.status.setHttpStatus(true);
        this._serviceRequestService.GetServiceRequestDetailByID(ID).subscribe(data => {

            this.ServiceRequestLogDetailList = data.srLogDetailList
            if (String(data.StatusID) == "4" || String(data.StatusID) == "5") {
                this.IsButtonHide = false;
            }
        }, (error) => {
            // this.status.setHttpStatus(false);

            this.error.handleError(error);
        }, () => {
            // this.spinnerService.hide();

            // this.status.setHttpStatus(false); 
        });
    }

    SubmitSRLog() {
        this.ServiceRequestLogDetail.controls.RequestEntityId.setValue(this.ID);
        this.ServiceRequestLogDetail.controls.Type.setValue('Work notes');
        if (this.ServiceRequestLogDetail.controls.LogText.value === null || this.ServiceRequestLogDetail.controls.LogText.value === '') {
            alert('Please fill mandatory fields.');
            return;
        }
        this.status.setHttpStatus(true);
        this._serviceRequestService.SaveServiceRequestLogDetail(this.ServiceRequestLogDetail.value).subscribe(data => {
            if (data.RequestIsSuccess) {
                if (data.RequestEntityId !== null) {
                    this.ServiceRequestLogDetail.controls.LogText.setValue("");
                    this.GetServiceRequestLogDetailByID(this.ID);
                }
            } else {
                alert(data.RequestMessage);
            }
        }, (error) => {
            this.status.setHttpStatus(false);
            this.error.handleError(error);
        },
            () => { this.status.setHttpStatus(false); });
    }
    openFileUploadDialog() {
        this._dialog.open(FileUploadComponent,
            {
                disableClose: true,
                height: '400px',
                width: '600px',
                data: { ID: this.ID, AttachmentFor: "ServiceRequest", StatusID: this.ServiceRequestForm.controls.StatusID.value }
            });
    }
    openMailTemplateDialog() {
        this.MailTEmplateDialogRef = this._dialog.open(MailTemplateComponent,
            {
                disableClose: true,
                height: '500px',
                width: '1000px',
                data: { ID: this.ID }

            });
        this.MailTEmplateDialogRef.afterClosed().subscribe(result => {
            this.GetServiceRequestDetailByID(this.ID);
        })

    }
    SearchActiveEmployee = (event) => {

        this._serviceRequestService.GetAssigmentToEmployee('FillCommonData/GetEmployeeForAssignedTo', event.query, this.ServiceRequestForm.controls.AssignmentGroupID.value).subscribe(result => {

            this.assignedToList = this.filterDataList(event.query, result);
        }, (error) => {
            this.error.handleError(error);
        }, () => {
        });
    }
    filterDataList(query, dataList: any): any[] {
        const filtered: any[] = [];
        for (let i = 0; i < dataList.length; i++) {
            this.filterList = dataList[i];
            if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(this.filterList);
            }
        }
        return filtered;
    }
    SetEmployeeDetails(event) {

        this.ServiceRequestForm.patchValue({
            AssignedTo: event.value.EmployeeGPN,
            AssignedToName: event.value.EmployeeName,
            AssignedToEmail: event.value.EmpEmail,

        })
        if (event.EmployeeGPN != "") {
            this.ServiceRequestForm.controls.StatusID.setValue("1");
        }

    }

    UpdateSR() {
        if (this.GetFormControls('IsRequestedFor').value == false) {
            this.GetFormControls('RequestedforHead').clearValidators();
            this.GetFormControls('RequestedforHead').updateValueAndValidity();
            // this.GetFormControls('RequestedForCUG').clearValidators();
            // this.GetFormControls('RequestedForCUG').updateValueAndValidity();
        }
        else {
            this.GetFormControls('RequestedforHead').setValidators([Validators.required]);
            this.GetFormControls('RequestedforHead').updateValueAndValidity();
            // this.GetFormControls('RequestedForCUG').clearValidators();
            // this.GetFormControls('RequestedForCUG').updateValueAndValidity();
        }
        if (!this.ServiceRequestForm.valid) {
            alert('Please fill mandatory fields.');
            this.showErrorsOnInvalidForm();
            return false;
        }
        if (this.ServiceRequestForm.controls.ResolutionTime.value == "" || this.ServiceRequestForm.controls.ResolutionTime.value == null) {
            alert('Please fill Resolution Time.');
            this.showErrorsOnInvalidForm();
            return false;
        }
        if (this.ServiceRequestForm.controls.StatusID.value == "1" && (this.ServiceRequestForm.controls.AssignedTo.value == "" || this.ServiceRequestForm.controls.AssignedTo.value == null)) {
            alert("Assigned To is mandatory for this status");
            return false;
        }
        this.status.setHttpStatus(true);
        this.ServiceRequestForm.controls.RequestEntityId.setValue(this.ID)
        this._serviceRequestService.UpdateServiceRequest(this.ServiceRequestForm.value).subscribe(data => {
            if (data.RequestIsSuccess) {
                if (data.RequestEntityId !== null) {
                    alert(data.RequestMessage);
                    this.GetServiceRequestDetailByID(this.ID);
                }
            } else {
                alert(data.RequestMessage);
            }
        }, (error) => {
            this.status.setHttpStatus(false);
            this.error.handleError(error);
        },
            () => { this.status.setHttpStatus(false); });
    }

    GetStatusName(event) {

        if (event.originalEvent !== undefined) {
            this.ServiceRequestForm.controls.StatusName.setValue(event.originalEvent.currentTarget.innerText);
        } else {
            const statusList = this.statusList.filter(x => x.value === event.value);
            this.ServiceRequestForm.controls.StatusName.setValue(statusList[0].label);
        }
    }
    GetpriorityName(event) {
        if (event.originalEvent !== undefined) {
            this.ServiceRequestForm.controls.Priority.setValue(event.originalEvent.currentTarget.innerText);
        } else {
            const priorityList = this.priorityList.filter(x => x.value === event.value);
            this.ServiceRequestForm.controls.Priority.setValue(this.priorityList[0].label);
        }
    }
    GetFormControls(controlName) {
        return this.ServiceRequestForm.controls[controlName];
    }
    showErrorsOnInvalidForm() {
        Object.keys(this.ServiceRequestForm.controls).forEach(field => {
            const control = this.ServiceRequestForm.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    SetRequesterforDetails(event) {
        this.ServiceRequestForm.patchValue({
            RequestedForGPN: event.EmployeeGPN,
            RequestedForCUG: event.EmpCUG,
            RequestedForName: event.EmpName,
            ReqLocation: event.EmpOffDescription
        });
    }

    clearAutoComplete(controlname) {
        if (controlname == 'RequesterForHead') {
            this.ServiceRequestForm.controls.RequestedForGPN.reset();
            this.ServiceRequestForm.controls.RequestedForCUG.reset();
            this.ServiceRequestForm.controls.RequestedForName.reset();
        }
        if (controlname == 'AssignedEmp') {
            this.ServiceRequestForm.controls.AssignedTo.reset();
            this.ServiceRequestForm.controls.AssignedToName.reset();
            this.ServiceRequestForm.controls.AssignedToEmail.reset();
        }
    }
    SearchAllActiveEmployee = (event) => {

        this._commonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
            this.requesterList = this.filterDataList(event.query, result);
        }, (error) => {
            this.error.handleError(error);
        }, () => {
        });
    }


    Download(ITem: any) {
        debugger;
        this._dataService.DownloadFile('Attachment/DownloadAttachmentByID?ID=' + this.ID + '&AttachmentId=' + ITem.AttachmentId).subscribe(data => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            saveAs(blob, ITem.AttachmentName);
        });

    }

}
